<template>
  <div
    :class="twMerge('flex justify-between text-gray-600 text-xs', $attrs.class)"
  >
    <NuxtLink
      v-if="partnerData?.permalink"
      :to="
        localePath({
          name: 'p-partnerPermalink',
          params: { partnerPermalink: partnerData.permalink },
        })
      "
      class="text-xs hover:underline"
    >
      {{ author }}
    </NuxtLink>
    <div v-else class="text-xs">{{ author }}</div>
    <div class="text-xs">
      <span v-if="context === 'articlePage'">{{
        $t('magazine.articlePage.datePrefix')
      }}</span>
      {{ date }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { twMerge } from 'tailwind-merge'
import type { Supplier } from '~/composables/types/event'

const partnerData = inject('partnerData') as Ref<Supplier>
const $localePath = useLocalePath()
const localePath = $localePath
withDefaults(
  defineProps<{
    date: string
    author: string
    context: string
  }>(),
  {
    date: '',
    author: '',
    context: 'homePage',
  }
)
</script>
